var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileBgOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 259,
    viewBox: "0 0 328 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314.353 0.891033C321.566 -0.108498 328 5.49519 328 12.7775L328 225.823C328 231.814 323.581 236.887 317.647 237.71L165.647 258.772C164.554 258.923 163.446 258.923 162.353 258.772L10.3529 237.71C4.41866 236.887 -1.01766e-05 231.814 -9.91476e-06 225.823L-6.02232e-07 12.7775C-2.83914e-07 5.49519 6.43372 -0.108513 13.6471 0.891019L162.353 21.4967C163.446 21.6482 164.554 21.6482 165.647 21.4967L314.353 0.891033Z",
    fill: "#314064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBgOne);
export default __webpack_public_path__ + "static/media/MobileBGOne.b01513a327e366b35ddfb7d55a5715fa.svg";
export { ForwardRef as ReactComponent };